interface Props {
    setWhenReadyRaiseHand: Function;
    persistentMode?: boolean;
}
const WhenReadyRaiseHandModal: React.FC<Props> = ({ setWhenReadyRaiseHand, persistentMode = false }) => {
    return (
        <>

            <div className={`generic-assesment-text-modal ${persistentMode ? 'persistent-mode' : ''}`}>
                {!persistentMode && (
                    <>
                        <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">When ready, raise  </h1>
                        <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">your hand to begin</h1>
                        <h1 className="fz-30 fw-700 lh-normal mb-0 align-center">the assessment.</h1>
                    </>
                )}
            </div>
        </>
    );
};
export default WhenReadyRaiseHandModal;

